<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/dingd/dingdwxlist',title:'订单管理'},{title:'箱单打印中英文对照表'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="产品编码">
							    <el-input clearable v-model="q.materialCode"></el-input>
							</el-form-item>
                            <el-form-item label="产品名称">
                                <el-input clearable v-model="q.materialName"></el-input>
                            </el-form-item>

                            <el-form-item label="中文描述">
                                <el-input clearable v-model="q.description"></el-input>
                            </el-form-item>
                            <el-form-item label="英文描述">
                                <el-input clearable v-model="q.descriptionEng"></el-input>
                            </el-form-item>
						</div>
                        <div class="h-formBtnOut h-columnCenter">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                                       @click="createdict">新建中英文对照</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
            <div class="h-table h-mrt30">
                <el-table
                        @selection-change="handleSelectionChange"
                        ref="ddtable"
                        :data="tableData"
                        stripe
						border
                        style="width: 100%"
                >
                    <el-table-column
                            type="selection"
                            width="40"
                            :label="all"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="materialCode"
                            label="产品编码"
							width="200"
							:show-overflow-tooltip="true"
                            >
                    </el-table-column>
                    <el-table-column
                            prop="materialName"
                            label="产品名称"
							width="300"
                           >
                    </el-table-column>
                    <el-table-column
                            prop="materialNameModel"
                            label="产品名称-英文"
                            width="200"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="description"
                            label="中文描述"
                            width="200"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="descriptionEng"
                            label="英文描述"
                            width="200"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="customsName"
                            label="报关名称"
                            width="200"
                    >
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="120"
                    >
                        <template slot-scope="scope">
                            <el-button
                                    class="h-tableLink h-btn"
                                    @click="handleEdit(scope.row)">修改</el-button>
                            <el-button
                                    class="h-tableLink h-btn"
                                    @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <div class="h-tableBL" style="margin:20px 0 0 20px;display:flex;justify-content:space-between">
                    <div>
                        <el-button
                                class="h-btn h-formBtn h-bgblueQ"
                                icon="h-el-icon h-el-icon-import"
                                style="margin-left:-20px;"
                                @click="exportExcel" >
                            批量导出
                        </el-button>
                        <el-button
                                class="h-btn h-formBtn h-bgblueQ"
                                icon="h-el-icon h-el-icon-export"
                                @click="uploaddownexcelflagbtn"
                               >
                            批量导入
                        </el-button>
                        <uploaddownexcel
                                :visible.sync="uploaddownexcelflag"
                                v-if="uploaddownexcelflag"
                                clsname="orderMainProductEngtableImportExcel"
                                :startrow="1"
                                @callback="uploadExcelFilecallback"/>
                    </div>
                    <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                        <pagination :page="q" @query="query"/>
                    </div>
                </div>
            </div>

            <div>
                <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2">
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>修改中英文对照</h1>
                            </div>
                        </div>
                    </div>
                    <div class="h-formLine">
                        <el-form ref="form" :model="f"
                                 :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">
                            <el-form-item label="产品编码" prop="materialCode" :rules="[
                              { required: true, message: '请输入产品编码', trigger: 'blur'},
                            ]" class="h-elformWrap-2">
                                <el-input v-model="f.materialCode"></el-input>
                            </el-form-item>
                            <el-form-item label="产品名称" prop="materialName" :rules="[
                                          { required: true, message: '请输入产品名称', trigger: 'blur'},
                                        ]" class="h-elformWrap-2">
                                <el-input v-model="f.materialName"></el-input>
                            </el-form-item>
                            <el-form-item label="产品英文名称" prop="materialNameModel" :rules="[
                                          { required: true, message: '请输入产品英文名称', trigger: 'blur'},
                                        ]" class="h-elformWrap-2">
                                <el-input v-model="f.materialNameModel"></el-input>
                            </el-form-item>

                            <el-form-item label="中文描述" prop="description" :rules="[
                                          { required: true, message: '请输入中文描述', trigger: 'blur'},
                                        ]" class="h-elformWrap-2">
                                <el-input v-model="f.description"></el-input>
                            </el-form-item>

                            <el-form-item label="英文描述" prop="descriptionEng" :rules="[
                                          { required: true, message: '请输入英文描述', trigger: 'blur'},
                                        ]" class="h-elformWrap-2">
                                <el-input v-model="f.descriptionEng"></el-input>
                            </el-form-item>
                            <el-form-item label="报关名称" prop="customsName" :rules="[
                                          { required: true, message: '请输入报关名称', trigger: 'blur'},
                                          {  max: 30, message: '长度在30个字符以内', trigger: 'blur' }
                                        ]" class="h-elformWrap-2">
                                <el-input v-model="f.customsName"></el-input>
                            </el-form-item>

                        </el-form>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="dialogFormVisible = false">取 消</el-button>
                        <el-button class="h-btn h-formBtn h-bgblue2" @click="saveOrUpdate">提交保存</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/dingd/ProductEngTable'
    import updownfile from "../../utils/updownfile";
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                uploaddownexcelflag: false,

                showYonghuflag: false,
                //table列表
                tableData: [],

                //查询属性
                q: {
                    materialCode:null,
                    materialName:null,
                    description:null,
                    descriptionEng:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表单
                f:{
                    id:null,
                    materialCode:null,
                    materialName:null,
                    materialNameModel:null,
                    description:null,
                    descriptionEng:null,
                    customsName:null,
                },
                optflag:'save',
                //弹出框
                dialogFormVisible: false,
                //表格
                multipleSelection: [],
            }
        },
        created() {
            this.query();
        },
        methods: {

            query() {
                ss.page(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },

            handleFilter() {
                this.query();

            },
            createdict(){
                this.f.id = null,
                this.f.materialCode = null,
                this.f.materialName = null,
                this.f.materialNameModel = null,
                this.f.description = null,
                this.f.descriptionEng = null,
                this.f.customsName = null,

                this.dialogFormVisible = true;
                this.optflag = 'save'
            },
            handleEdit(obj){
                //设置提交的字段
                for(var i in this.f){
                    this.f[i] = obj[i];
                }
                this.dialogFormVisible = true;
                this.optflag = 'update'
            },
            handleDelete(obj){
                this.$msg.confirm("确认删除?",()=>{
                    ss.updateById({id:obj.id,delflag:0}).then(rd=>{
                        this.$msg.msgs("删除成功！");
                        this.query();
                    });
                })
            },
            //保存数据字典
            saveOrUpdate(){
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        var retobj = null;
                        if(this.optflag == 'save'){
                            retobj = ss.insert(this.f);
                        }else if(this.optflag =="update"){
                            retobj = ss.updateById(this.f);
                        }
                        retobj.then(rd=>{
                            this.dialogFormVisible = false;
                            this.$msg.msgs("操作成功！");
                            this.query();
                        });
                    } else {
                        return false;
                    }
                });
            },
            //选中
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //明细导出
            exportExcel() {
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.id);
                });
                updownfile.down("/api/swyl/v1/dingdProductEng/downloadExcel", idlist, "post", 'data');
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
        }
    }
</script>
